import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  regionGroups: [],
  aptFilters: [],
  aptGroups: [],
};

const reducers = {
  // payload: RegionGroupDto[]
  getRegionGroups(state, action) {
    state.regionGroups = Array.isArray(action.payload) ? action.payload : [];
  },

  // payload: RegionGroupDto
  createRegionGroup(state, action) {
    const dto = action.payload;
    if (!dto) return;

    // 혹시 같은 id가 이미 있으면 교체(서버가 upsert처럼 동작해도 안전)
    const idx = state.regionGroups.findIndex((g) => g?.id === dto?.id);
    if (idx >= 0) state.regionGroups[idx] = dto;
    else state.regionGroups.unshift(dto); // 최신을 앞에
  },

  // payload: id (number | string) or { id }
  deleteRegionGroup(state, action) {
    const id = action.payload?.id ?? action.payload;
    if (id == null) return;

    state.regionGroups = state.regionGroups.filter((g) => g?.id !== id);
  },

  // payload: RegionGroupDto
  updateRegionGroup(state, action) {
    const dto = action.payload;
    if (!dto?.id) return;

    const idx = state.regionGroups.findIndex((g) => g?.id === dto.id);
    if (idx >= 0) state.regionGroups[idx] = dto;
    else state.regionGroups.unshift(dto); // 없으면 새로 추가(안전)
  },

  // =====================
  // AptFilter Reducers
  // =====================

  // payload: AptFilterDto[]
  getAptFilters(state, action) {
    state.aptFilters = Array.isArray(action.payload) ? action.payload : [];
  },

  // payload: AptFilterDto
  createAptFilter(state, action) {
    const dto = action.payload;
    if (!dto) return;

    const idx = state.aptFilters.findIndex((f) => f?.id === dto?.id);
    if (idx >= 0) state.aptFilters[idx] = dto;
    else state.aptFilters.unshift(dto);
  },

  // payload: id (number | string) or { id }
  deleteAptFilter(state, action) {
    const id = action.payload?.id ?? action.payload;
    if (id == null) return;

    state.aptFilters = state.aptFilters.filter((f) => f?.id !== id);
  },

  // payload: AptFilterDto
  updateAptFilter(state, action) {
    const dto = action.payload;
    if (!dto?.id) return;

    const idx = state.aptFilters.findIndex((f) => f?.id === dto.id);
    if (idx >= 0) state.aptFilters[idx] = dto;
    else state.aptFilters.unshift(dto);
  },

  // =====================
  // AptGroup Reducers
  // =====================

  // payload: AptGroupDto[]
  getAptGroups(state, action) {
    state.aptGroups = Array.isArray(action.payload) ? action.payload : [];
  },

  // payload: AptGroupDto
  createAptGroup(state, action) {
    const dto = action.payload;
    if (!dto) return;

    const idx = state.aptGroups.findIndex((g) => g?.id === dto?.id);
    if (idx >= 0) state.aptGroups[idx] = dto;
    else state.aptGroups.unshift(dto);
  },

  // payload: id (number | string) or { id }
  deleteAptGroup(state, action) {
    const id = action.payload?.id ?? action.payload;
    if (id == null) return;

    state.aptGroups = state.aptGroups.filter((g) => g?.id !== id);
  },

  // payload: AptGroupDto
  updateAptGroup(state, action) {
    const dto = action.payload;
    if (!dto?.id) return;

    const idx = state.aptGroups.findIndex((g) => g?.id === dto.id);
    if (idx >= 0) state.aptGroups[idx] = dto;
    else state.aptGroups.unshift(dto);
  },
};

export const slice = createSlice({
  name: "group",
  initialState,
  reducers,
});

export const { reducer } = slice;
